var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-card',{attrs:{"width":"100vw","height":"90vh","elevation":"0"}},[_c('v-container',{attrs:{"fill-height":""}},[_c('v-col',{attrs:{"cols":"12","justify":"center","align":"center"}},[_c('v-progress-circular',{attrs:{"width":5,"size":100,"color":"primary","indeterminate":""}}),_c('div',[_vm._v("Cargando propiedades...")])],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }